export default __webpack_public_path__ + "static/media/rey-seven-_nm_mZ4Cs2I-unsplash.03f2484e.jpg";